import { axios } from 'services/axios';

const getCompany = async (companyId) => {
    const res = await axios.get(`/company/${companyId}`, {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        },
    });

    return res.data;
};

export default getCompany;
